export const doubleQuote = '"';
export const singleQuote = "'";
